module.exports = __webpack_public_path__ + "static/media/grn.57da7ed5.svg";